import Vue from 'vue'
import router from '../router'
import VueResource from 'vue-resource'

Vue.use(VueResource)

export default {
  login: async (obj) => {
    try {
      const xhr = await Vue.http.post('cliente/auth/login', obj).then(res => res.json())

      if (xhr && xhr.Ok) {
        localStorage.setItem('STORAGE.DATA', JSON.stringify(xhr))
        localStorage.setItem('STORAGE.TOKEN', xhr.Token)

        return xhr
      }

      return xhr
    } catch (e) {
      return e
    }
  },

  loginPersonifica: async (hash) => {
    try {
      const xhr = await Vue.http.get(`cliente/auth/personificar/${hash}`).then(res => res.json())

      if (xhr && xhr.Ok) {
        localStorage.setItem('STORAGE.DATA', JSON.stringify(xhr))
        localStorage.setItem('STORAGE.TOKEN', xhr.Token)

        return xhr
      }

      return xhr
    } catch (e) {
      return e
    }
  },

  forget: (obj) => Vue.http.post('cliente/auth/recover-password', obj).then(res => res.json()),

  logout (redirect = true) {
    Vue.http.headers.common['Authorization'] = ''
    localStorage.removeItem('STORAGE.TOKEN')
    localStorage.removeItem('STORAGE.DATA')
    localStorage.removeItem('STORAGE.CONTRATOATUAL')

    if (redirect) router.push('/login')
  }, // logout()

  isLoggedIn () {
    let jwt = localStorage.getItem('STORAGE.TOKEN') || ''
    Vue.http.headers.common['Authorization'] = jwt

    return !!jwt
  }, // isLoggedIn()

  getAuthHeader () {
    return {
      Authorization: localStorage.getItem('STORAGE.TOKEN')
    }
  } // getAuthHeader()
}
